(function (scope) {
  'use strict';
  var source = 'https://www.gov.cn/zhengce/zhengceku/202511/content_7047091.htm';
  var version = 'ct-holidays-2026-official-v1';
  // Dates are official. Only the three existing commercial holiday mappings retain +18%.
  var years = {
    2026: [
      {start: '2026-01-01', end: '2026-01-03', name: 'New Year', supplement: null},
      {start: '2026-02-15', end: '2026-02-23', name: 'Spring Festival', supplement: 18},
      {start: '2026-04-04', end: '2026-04-06', name: 'Qingming', supplement: null},
      {start: '2026-05-01', end: '2026-05-05', name: 'May Day', supplement: 18},
      {start: '2026-06-19', end: '2026-06-21', name: 'Dragon Boat Festival', supplement: null},
      {start: '2026-09-25', end: '2026-09-27', name: 'Mid-Autumn Festival', supplement: null},
      {start: '2026-10-01', end: '2026-10-07', name: 'National Day Golden Week', supplement: 18}
    ]
  };
  function quote(note, label) {
    return {season: 'quote', supp: 0, label: label || 'Planner quote required', note: note,
      quoteRequired: true, calendarVersion: version, source: source};
  }
  function resolveParts(monthValue, dayValue, yearValue) {
    var month = Number(monthValue), day = Number(dayValue), year = Number(yearValue);
    if (!Number.isInteger(year) || year < 1000 || !Number.isInteger(month) || !Number.isInteger(day))
      return quote('Choose a complete valid start date before payment.');
    var date = new Date(Date.UTC(year, month - 1, day));
    if (date.getUTCFullYear() !== year || date.getUTCMonth() + 1 !== month || date.getUTCDate() !== day)
      return quote('Choose a complete valid start date before payment.');
    if (!Object.prototype.hasOwnProperty.call(years, year))
      return quote('The official holiday calendar for ' + year + ' is not yet verified here. Your planner must confirm the date and price before payment.');
    var iso = String(year) + '-' + String(month).padStart(2, '0') + '-' + String(day).padStart(2, '0');
    var season = month >= 9 && month <= 11 ? 'autumn' : month >= 6 && month <= 8 ? 'summer' : month >= 3 && month <= 5 ? 'spring' : 'winter';
    for (var i = 0; i < years[year].length; i++) {
      var holiday = years[year][i];
      if (iso >= holiday.start && iso <= holiday.end) {
        if (holiday.supplement === null)
          return quote(holiday.name + ' dates are officially confirmed; the applicable holiday price must be confirmed in your quote before payment.', holiday.name + ' - quote required');
        return {season: season, supp: holiday.supplement, label: holiday.name,
          note: 'Official ' + year + ' holiday dates; existing holiday variant selected. Availability still requires planner confirmation.',
          quoteRequired: false, calendarVersion: version, source: source};
      }
    }
    var rates = {winter: 0, spring: 10, summer: 8, autumn: 14};
    var labels = {winter: 'Quiet winter', spring: 'Classic spring', summer: 'Summer window', autumn: 'Autumn peak'};
    return {season: season, supp: rates[season], label: labels[season],
      note: 'Outside the published ' + year + ' holiday periods. Existing seasonal variant applies.',
      quoteRequired: false, calendarVersion: version, source: source};
  }
  scope.CTHolidayCalendar = {version: version, resolveParts: resolveParts};
})(typeof window !== 'undefined' ? window : this);
